import React, { useEffect, useState } from 'react';
import ProductCard from '../Components/ProductCards/ProductCard';
import Product from '../Types/Product';
import { getListingPricesJson } from '../Components/NavisionPrice/services/NavisionPriceService';
import { getListingstocksJson } from '../Components/NavisionStock/services/NavisionStockService';
import { useTypedSelector } from '../Hooks/useTypedSelector';
import { ProductStocks } from '../Components/NavisionStock/types/ProductStocks';
import useShowBothPrices from '../Hooks/useShowBothPrices';

export interface ProductNoSliderProps {
  products: Product[];
  numPerRow: number;
}

const ProductBlockNoSlider = (props: ProductNoSliderProps) => {
  const { products, numPerRow } = props;
  const [navisionPrices, setNavisionPrices] = useState<
    ProductPriceResponseItem[]
  >([]);
  const showBothPrices = useShowBothPrices();
  const [navisionStocks, setNavisionStocks] = useState<ProductStocks[]>(
    []
  );
  const { currentType: currentPriceToggleType } = useTypedSelector(
    (state) => state.priceToggle
  );
  const { isInBuyableState } = useTypedSelector(
    (state) => state.buyableState
  );

  useEffect(() => {
    const fetchData = async () => {
      const productIds = products?.map((p) => p?.id);

      if (currentPriceToggleType != null && productIds.length) {
        const resultStocks = await getListingstocksJson(productIds);
        if (resultStocks != null && resultStocks.success) {
          setNavisionStocks(resultStocks.items);
        } else {
          console.log(
            `Failed to fetch Navision stocks for productId: ${productIds.toString()}`
          );
        }
      }

      if (showBothPrices && productIds.length) {
        const resultPrices = await getListingPricesJson(productIds);
        setNavisionPrices(resultPrices);
      }
    };

    fetchData();
  }, []);

  const cells = {
    1: 'grid-cols-1',
    2: 'grid-cols-1 md:grid-cols-2',
    3: 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3',
    4: 'grid-cols-2 lg:grid-cols-4',
    5: 'grid-cols-2 lg:grid-cols-5',
    6: 'grid-cols-2 md:grid-cols-3 lg:grid-cols-6',
  };

  return (
    <div className={`grid gap-6 ${cells[numPerRow]}`}>
      {products.map((product, idx) => (
        <ProductCard
          key={product.id + 'noslide' + idx}
          product={product}
          showBothPrices={showBothPrices}
          navisionPrice={navisionPrices?.find(
            (p) => p?.productId === product.id
          )}
          navisionStock={navisionStocks?.find(
            (p) => p?.productId === product?.id
          )}
          currentPriceToggleType={currentPriceToggleType}
          isInBuyableState={isInBuyableState}
        />
      ))}
    </div>
  );
};

export default ProductBlockNoSlider;
